import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ed27fef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BigContainer" }
const _hoisted_2 = { class: "BigHeader" }
const _hoisted_3 = {
  class: "D-Flex HeaderFlex",
  style: {}
}
const _hoisted_4 = { class: "F-Bold F1_75em BigHeaderText" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesColSplitter MobileHider" }, null, -1))
const _hoisted_6 = { class: "HeaderButtons" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  style: {},
  class: "V-Auto"
}
const _hoisted_9 = {
  key: 1,
  style: {"white-space":"nowrap"},
  class: "V-Auto"
}
const _hoisted_10 = {
  class: "V-Auto",
  style: {"white-space":"nowrap"}
}
const _hoisted_11 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesTabs = _resolveComponent("CookiesTabs")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_CookiesFilterPannel = _resolveComponent("CookiesFilterPannel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.AccessableTabs.length !== 1 ? _ctx.Name : _ctx.Translate(_ctx.AccessableTabs[0].Name)), 1),
          (_ctx.AccessableTabs.length > 1)
            ? (_openBlock(), _createBlock(_component_CookiesTabs, {
                key: 0,
                Router: true,
                Default: _ctx.Tabs[0],
                Tabs: _ctx.Tabs
              }, null, 8, ["Default", "Tabs"]))
            : _createCommentVNode("", true),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Buttons, (button) => {
              return (_openBlock(), _createElementBlock("div", {
                key: button.Name,
                class: ""
              }, [
                (button.Visible === undefined || button.Visible)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (button.this.ButtonsFunctions(button.Function)),
                      class: _normalizeClass([button.Class, "DialogHeaderButton BGMain F1_25em CookiesFade D-Flex"]),
                      style: _normalizeStyle(button.Style)
                    }, [
                      (button.Icon)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                            _createVNode(_component_CookiesIcon, {
                              Color: button.IconColor ? button.IconColor : { ColorA: _ctx.Theme.BackShader, ColorB: _ctx.Theme.BackShader } ,
                              class: "SQR1_5em",
                              ID: button.Icon
                            }, null, 8, ["Color", "ID"])
                          ]))
                        : _createCommentVNode("", true),
                      (button.Indent)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(button.Indent), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.Translate(button.Name)), 1)
                    ], 14, _hoisted_7))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", {
          onFocusout: _cache[4] || (_cache[4] = ($event: any) => (_ctx.FocusOut())),
          class: "D-Flex CookiesSearchInputContainer",
          style: {"margin":"auto","margin-inline-end":"0em"}
        }, [
          (_ctx.Filter)
            ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ShowFilter = !_ctx.ShowFilter)),
                ToolTip: _ctx.Translate('Filter'),
                class: "CookiesSearchIcon FilterButton HoverUp",
                ID: ('Filter' as IconsIDs)
              }, null, 8, ["ToolTip"]))
            : _createCommentVNode("", true),
          _createVNode(_component_CookiesIcon, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.OpenSearch())),
            ToolTip: _ctx.Translate('Search'),
            Color: {ColorA: _ctx.Search !== '' ? _ctx.Theme.UserColors.fourth : ''} as IconColor,
            class: "CookiesSearchIcon HoverUp",
            ID: ('Search' as IconsIDs),
            style: {"padding-inline-end":"1.5em"}
          }, null, 8, ["ToolTip", "Color"]),
          _withDirectives(_createElementVNode("input", {
            ref: 'HeaderSearch',
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.Search) = $event)),
            class: _normalizeClass(["CookiesSearchInput CookiesFade color2 F1_25em", _ctx.PhoneSearchEnabled ? '' : 'D-None']),
            style: _normalizeStyle(_ctx.PhoneSearchEnabled ? 'display: block': ''),
            placeholder: _ctx.Translate('Search...')
          }, null, 14, _hoisted_11), [
            [_vModelText, _ctx.Search]
          ]),
          _createVNode(_component_CookiesIcon, {
            ToolTip: _ctx.Translate('Search'),
            style: _normalizeStyle([_ctx.PhoneSearchEnabled ? 'display: block;': 'display: none;', {"inset-inline-end":"2.1em","top":"1.25em"}]),
            class: "HeaderSmall SQR2em V-Auto HoverUp P-Abs",
            ID: ('Search' as IconsIDs)
          }, null, 8, ["ToolTip", "style"]),
          _createVNode(_component_CookiesIcon, {
            ToolTip: _ctx.Translate('Remove Search'),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.RemoveSearch())),
            style: _normalizeStyle([_ctx.PhoneSearchEnabled ? 'display: block;': 'display: none;', {"inset-inline-end":"4.5em","top":"1.5em"}]),
            class: "HeaderSmall SQR1_5em V-Auto HoverUp P-Abs",
            ID: ('Delete' as IconsIDs)
          }, null, 8, ["ToolTip", "style"])
        ], 32)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["BigBody P-Rel TableButtonsPusher", _ctx.FillBodyHeight])
      }, [
        _createVNode(_component_router_view, {
          Search: _ctx.Search,
          ParentThis: _ctx.This
        }, null, 8, ["Search", "ParentThis"])
      ], 2)
    ]),
    (_ctx.Filter)
      ? (_openBlock(), _createBlock(_component_CookiesFilterPannel, {
          key: 0,
          onCloseMe: _cache[5] || (_cache[5] = ($event: any) => (_ctx.ShowFilter = false)),
          FilterSettings: _ctx.Filter,
          ShowFilter: _ctx.ShowFilter
        }, null, 8, ["FilterSettings", "ShowFilter"]))
      : _createCommentVNode("", true)
  ], 64))
}